import { render } from "./EmploiMain.vue?vue&type=template&id=ae92870e&scoped=true"
import script from "./EmploiMain.vue?vue&type=script&lang=js"
export * from "./EmploiMain.vue?vue&type=script&lang=js"

import "./EmploiMain.vue?vue&type=style&index=0&id=ae92870e&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-ae92870e"]])

export default __exports__